export const defaultLineCreatorValue = () => {
    return {
        lines_cordinates : [],
        line_styles:{
            bg_color:"#000"
        },
        line_width:4,
        box_styles:{
            height:200,
            width:200
        }
    };
  }